import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';


const Header = () => {
  return (
    <Navbar expand="lg" fixed="top" className="custom-navbar">
      <Container>
        <Navbar.Brand className="text-white">
          <img
            src="images/Logo Chat Page ya editado.png"
            width="45"
            height="45"
            className="d-inline-block align-top me-2"
            
          />
          <em>Estudio jurídico <strong>Cordoba & Asociados</strong></em>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="custom-nav w-100">
            <Nav.Link href="#nosotros" className="text-white px-3 nav-link-custom"><em>| Sobre nosotros |</em></Nav.Link>
            <Nav.Link href="#Servicios" className="text-white px-3 nav-link-custom"><em>| Servicios Legales |</em></Nav.Link>
            <Nav.Link href="#Testimonios" className="text-white px-3 nav-link-custom"><em>| Testimonios |</em></Nav.Link>
            <Nav.Link href="#Noticias" className="text-white px-3 nav-link-custom"><em>| Noticias |</em></Nav.Link>
            <Nav.Link href="#Contact" className="text-white px-3 nav-link-custom"><em>| Contacto |</em></Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;